module.exports = __webpack_public_path__ + "img/18.ac280435.png";